import { render, staticRenderFns } from "./SectionBlog.vue?vue&type=template&id=48382984"
import script from "./SectionBlog.vue?vue&type=script&lang=js"
export * from "./SectionBlog.vue?vue&type=script&lang=js"
import style0 from "./SectionBlog.vue?vue&type=style&index=0&id=48382984&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./SectionBlog.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports